var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "button",
    {
      staticClass: "position-relative",
      attrs: { disabled: _vm.isStateLoading },
      on: {
        click: function ($event) {
          $event.stopPropagation()
          $event.preventDefault()
          return _vm.$emit("click", $event)
        },
      },
    },
    [
      _vm.isStateLoading
        ? _c(
            "span",
            {
              staticClass:
                "position-absolute d-flex top-0 left-0 h-100 w-100 align-items-center justify-content-center",
            },
            [_c("i", { staticClass: "fa fa-spin btn-loading-animation" })]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.icon && !_vm.showIconAfterText
        ? _c("span", { class: { "opacity-0": _vm.isStateLoading } }, [
            _c("i", { class: _vm.icon }),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("span", { class: { "opacity-0": _vm.isStateLoading } }, [
        _vm._v("\n        " + _vm._s(_vm.text) + "\n    "),
      ]),
      _vm._v(" "),
      _vm.icon && _vm.showIconAfterText
        ? _c("span", { class: { "opacity-0": _vm.isStateLoading } }, [
            _c("i", { class: _vm.icon }),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }